import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import axios from "axios";
import "../css/outletForm.css";

const { Option } = Select;

const OutletForm = ({
  isModalVisible,
  handleOk,
  handleCancel,
  item,
  businessId,
}) => {
  const [form] = Form.useForm();
  const [industryType, setIndustryType] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item);
      setIndustryType(item.services);
    }
  }, [item, form]);

  const handleIndustryChange = (value) => {
    setIndustryType(value);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const formData = { ...values, business: businessId };
      console.log(formData);

      if (businessId) {
        // Specific dynamic route - Make axios POST request
        await axios.post(`${apiUrl}/api/saveOutlet`, formData);
        handleOk();
        form.resetFields();
      } else {
        // Other routes - Use handleOk
        handleOk(formData);
        form.resetFields();
      }
    } catch (error) {
      console.error("Error saving outlet data:", error);
    }
  };

  const getUnitLabel = () => {
    switch (industryType) {
      case "Transportation":
        return "No of Vehicle";
      case "Manufacturing":
        return "No of Food Handlers";
      case "Trade and Retail":
      case "Storage and Warehouse":
        return "Area (Sq. ft)";
      case "Catering":
        return "No of Food Handlers";
      default:
        return "Enter the Unit";
    }
  };

  return (
    <Modal
      className="h-80vh overflow-hidden"
      title={<span className="text-xl">Add Outlet </span>}
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={
            <span className="text-gray-600 font-semibold">Outlet Name</span>
          }
          name="branch_name"
          rules={[{ required: true, message: "Please enter branch name" }]}
        >
          <Input
            placeholder="Enter the name of the branch"
            className="placeholder-gray-400 p-3 rounded-lg w-full"
          />
        </Form.Item>
        <Form.Item
          label={
            <span className="text-gray-600 font-semibold">
              FSSAI License Number
            </span>
          }
          name="fssai_license_number"
          rules={[
            {
              required: false,
              message: "Please enter the FSSAI License Number",
            },
            {
              len: 14,
              message:
                "FSSAI License Number must be exactly 14 characters long",
            },
            {
              pattern: /^[0-9]+$/,
              message: "FSSAI License Number must be numeric only",
            },
          ]}
        >
          <Input
            placeholder="Enter FSSAI NO"
            className="placeholder-gray-400 p-3 rounded-lg w-full"
          />
        </Form.Item>
        <Form.Item
          label={
            <span className="text-gray-600 font-semibold">
              Type Of Industry
            </span>
          }
          name="type_of_industry"
          rules={[
            { required: true, message: "Please select an industry Type" },
          ]}
        >
          <Select
            placeholder="Select industry Type"
            className="w-full"
            size="large"
            onChange={handleIndustryChange}
          >
            <Option value="Catering">Catering</Option>
            <Option value="Manufacturing">Manufacturing</Option>
            <Option value="Trade and Retail">Trade and Retail</Option>
            <Option value="Transportation">Transportation</Option>
            <Option value="Storage and Warehouse">Storage and Warehouse</Option>
          </Select>
        </Form.Item>

        {industryType && (
          <Form.Item
            label={
              <span className="text-gray-600 font-semibold">
                {getUnitLabel()}
              </span>
            }
            name="unit"
            rules={[{ required: true, message: "Please enter the unit" }]}
          >
            <Input
              placeholder="Enter the unit"
              className="placeholder-gray-400 p-3 rounded-lg w-full"
            />
          </Form.Item>
        )}
        {industryType === "Manufacturing" && (
          <Form.Item
            label={
              <span className="text-gray-600 font-semibold">
                No. Of Production Line
              </span>
            }
            name="no_of_production_line"
            rules={[{ required: true, message: "Please enter the unit" }]}
          >
            <Input
              placeholder="Enter the unit"
              className="placeholder-gray-400 p-3 rounded-lg w-full"
            />
          </Form.Item>
        )}
        <Form.Item
          name="vertical_of_industry"
          label={
            <span className="text-gray-600 font-semibold">
              Vertical of Industry
            </span>
          }
          rules={[
            { required: true, message: "Please select an  Vertical of Industry" },
          ]}
        >
          <Select placeholder="Select Industry Vertical" size={"large"}>
            <Option value="Sweet Shop">Sweet Shop</Option>
            <Option value="Meat Retail">Meat Retail</Option>
            <Option value="Hub">Hub</Option>
            <Option value="Market">Market</Option>
            <Option value="General Manufacturing">General Manufacturing</Option>
            <Option value="Meat & Meat Processing">
              Meat & Meat Processing
            </Option>
            <Option value="Dairy Processing">Dairy Processing</Option>
            <Option value="Catering">Catering</Option>
            <Option value="Transportation">Transportation</Option>
            <Option value="Storage/Warehouse">Storage/Warehouse</Option>
            <Option value="Institute Canteen">Institute Canteen</Option>
            <Option value="Industrial Canteen">Industrial Canteen</Option>
            <Option value="Temple Kitchen">Temple Kitchen</Option>
            <Option value="Bakery">Bakery</Option>
            <Option value="Restaurant">Restaurant</Option>
            <Option value="Slaughter House">Slaughter House</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="gst_number"
          label={
            <span className="text-gray-600 font-semibold">GST Number</span>
          }
          rules={[
            {
              required: false,
              message: "Please enter GST number",
            },
            {
              pattern: /^[A-Za-z0-9]{15}$/,
              message: "GST number must be 15 alphanumeric characters",
            },
          ]}
        >
          <Input
            placeholder="Enter your GST number"
            className="placeholder-gray-400 p-3 rounded-lg"
          />
        </Form.Item>
        <Form.Item
          label={
            <span className="text-gray-600 font-semibold">Contact Number</span>
          }
          name="contact_number"
          rules={[{ required: false, message: "Please enter contact number" }]}
        >
          <Input
            placeholder="Enter primary contact number"
            className="placeholder-gray-400 p-3 rounded-lg w-full"
          />
        </Form.Item>
        <Form.Item
          label={
            <span className="text-gray-600 font-semibold">Contact Person</span>
          }
          name="contact_person"
          rules={[{ required: false, message: "Please enter contact person" }]}
        >
          <Input
            placeholder="Enter contact person name"
            className="placeholder-gray-400 p-3 rounded-lg w-full"
          />
        </Form.Item>
        <Form.Item
          label={<span className="text-gray-600 font-semibold">City</span>}
          name="city"
          rules={[{ required: true, message: "Please enter city" }]}
        >
          <Input
            placeholder="Enter city of outlet"
            className="placeholder-gray-400 p-3 rounded-lg w-full"
          />
        </Form.Item>
        <div className="flex justify-center">
          <div className="flex justify-between space-x-2">
            <Button className="mr-5" onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" className="ml-5" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default OutletForm;
